/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  static construct ({ queries })
  {
    return { users: queries.getUsers() };
  }


  constructor (props)
  {
    this.props = props;

    this.users = this.props.users.map(user => props.parent.getUser(user.id));
    this.users = this.users.filter(user => !user.isAncientUser());
    this.users = this.users.sort((lhs, rhs) => rhs.getPoints() - lhs.getPoints());
  }


  getAll ()
  {
    return this.users;
  }


  getUser (index)
  {
    return this.users[index];
  }


  getLength ()
  {
    return this.users.length;
  }


};

